import { FeaturedOnRow } from './styled';
import { usePageTranslation } from '../../hooks/usePageTranslation';

export const FeaturedOn = () => {
  const t = usePageTranslation();
  return (
    <FeaturedOnRow justifyContent="space-around">
      <p>{t('featured.title')}</p>
      <img
        src="//images.ctfassets.net/n07nr2koi959/4xuRuzu8teuEhOx6DIw9Cn/45be4bbf719c2a9f607e1376b984005f/logos-forbes-afr-cnbc.png"
        alt={t('featured.forbesAfrCnbc')}
      />
      <img
        src="//images.ctfassets.net/n07nr2koi959/5Kaf9Leh9Mdf8PY3nUj25C/93e4769434b08094f9816d33fe78f77c/logos-techcrunch-skynews.png"
        alt={t('featured.techcrunchSkynews')}
      />
    </FeaturedOnRow>
  );
};
